<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, onUpdated, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();

const route = useRoute();

onMounted(() => {
  setTimeout(() => {
    console.log(route.params, route.query);
    const salonId = +route.params.SALON_ID;
    const orderId = route.query.order_id;

    store.state.salonId = salonId;
    store.state.orderId = orderId;

    if (salonId) {
      store.dispatch("getDesignsBySalonId");
      store.dispatch("getAllLoyalityTypes").then(() => {
        if (orderId) {
          console.log(route);
          store.dispatch("getCurrentPagePayment").then(() => {
            if (route.query.pay === "success") {
              store.dispatch("postSuccessPagePaymentStatus");
            }
          });
        }
      });
    }
  }, 20);


});
</script>

<style lang="scss">
@import "@/assets/variables.scss";
.container {
  max-width: 1270px;
  margin: 0 auto;
  padding: 24px 16px 40px 16px;
}
.buttonline {
  display: grid;
  grid-template-columns: 75px auto;
  grid-gap: 16px;
  margin-top: auto;
  padding-top: 16px;
}
.button {
  width: 100%;
  display: flex;
  cursor: pointer;
  padding: 8px 16px 8px 16px;
  border-radius: 12px;
  border: 1px solid #e0d8c4;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
}

@media (hover: hover) and (pointer: fine) {
  .button:hover,
  .button.bezh {
    color: $color_2;
  }
}
.button.next {
  background-color: $background-color_2;
  border-color: $border-color_1;
}
.button.next.active {
  background-color: $background-color_3;
  color: $color_2;
}
.button.bezh {
  background-color: $background-color_4;
  color: $color_2;
  border-color: $border-color_3;
}
.button.bezh.active {
  background-color: $background-color_3;
  color: $color_2;
}

.button.grey {
  background-color: $background-color_4;
  border: 0;
  color: $color_2;
}
.button.grey.active {
  border: solid 4px $background-color_3;
  padding: 5px 16px 4px 16px;
}
.input {
  border: 1px solid #bfbfbf;
  border-radius: 8px;
  padding: 13px 10px;
  color: $color_3;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  background-color: $background-color_6;
  display: block;
  width: 100%;
  padding: 12px 8px;

  &._disabled-text-hide:disabled {
    color: rgba(0, 0, 0, 0);
  }
  &._disabled-text-hide:disabled::placeholder {
    color: rgba(0, 0, 0, 0) !important;
  }
}
.text {
  margin-top: 8px;
  font-weight: 400;
  margin-bottom: 24px;
}
.text2 {
  margin-top: 8px;
  font-weight: 400;
}
.text3 {
  color: $color_1;
  font-size: 14px;
  line-height: 18.76px;
  font-weight: 300;
}
input[type="radio"] {
  display: none;
}
label {
  cursor: pointer;
  display: block;
  position: relative;
  padding-left: 26px;
  > * {
    color: $color_4;
  }
  &::before {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 16px;
    width: 16px;
    content: "";
    border: 1px solid #bfb9ae;
    border-radius: 50%;
    background-color: $background-color_7;
  }
}
input {
  &:checked {
    + {
      label {
        &::before {
          background-image: url('data:image/svg+xml;utf8, <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="%23E0D8C4"/><rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="%23ECE6DC"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8727 6.87449C14.9866 6.98839 14.9866 7.17307 14.8727 7.28697L8.45608 13.7036C8.34217 13.8175 8.1575 13.8175 8.0436 13.7036L5.12693 10.787C5.01303 10.6731 5.01303 10.4884 5.12693 10.3745C5.24083 10.2606 5.42551 10.2606 5.53941 10.3745L8.24984 13.0849L14.4603 6.87449C14.5742 6.76059 14.7588 6.76059 14.8727 6.87449Z" fill="%2326201B"/></svg>');
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
    }
  }
}
.inputwrapper {
  position: relative;
  margin-bottom: 16px;
}
.input.error {
  border-color: $border-color_4;
  color: $color_5;
}
.errorblock {
  position: absolute;
  background-color: $background-color_9;
  color: $color_2;
  padding: 7px 26px 7px 16px;
  border-radius: 16px 16px 16px 4px;
  top: -22px;
  left: 50%;
  text-align: left;
  border: none;
  box-shadow: none;
  &.close {
    cursor: pointer;
  }
  &.close:after {
    content: '+';
    position: absolute;
    right: 7px;
    top: 0px;
    font-size: 18px;
    transform: rotate(45deg);
  }
}
.finish {
  .button.bezh {
    margin-top: 16px;
  }
}
.text.sms {
  margin: 32px 0 16px;
}
.kod {
  text-align: center;
  margin-top: 24px;
}
.time {
  font-weight: 400;
}
.confirm {
  display: grid;
  grid-template-columns: auto 134px;
  align-items: center;
  grid-gap: 8px;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 16px;
}
.number {
  border: 1px solid #bfbfbf;
  padding: 12px 8px;
  border-radius: 8px;
  color: $color_4;
}
.ready {
  border-radius: 8px;
  background-color: $background-color_8;
  color: $color_2;
  padding: 12px 8px;
  text-align: center;
}
@media (min-width: 1024px) {
  .button {
    font-size: 16px;
    font-size: 16px;
  }
  .button.grey {
    font-size: 14px;
  }
  label {
    font-size: 16px;
  }
  .text {
    font-size: 16px;
  }
}
</style>
